import { useParams } from "react-router-dom"
import React, { useState, useEffect, Fragment } from 'react'
import api from "../../../../services/api"
import DateView from "../../../../utils/date"
import HeaderSession from "../../../../utils/headerSession"
import NavLateral from "./navLateral"
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs"
import Email from "../../../../utils/email"
import InfoFieldGroup from "../../../../utils/InfoField/InfoFieldGroup"
import CreateObservacaoFarmacovigilancia from "./createObservacaoFarmacovigilancia"
import { useSelector } from "react-redux"
import ResponseFarmacovigilancia from "./responseFarmacovigilancia"
import AddAnexos from "../../../../pages/home/services/farmacovigilancia/addAnexos"
import { AnaliseNaranjoPdf } from "./documentosGerados/analiseNarranjoPdf"
import { FichaNotificacaoProdutosBaixaQualidadePdf } from "./documentosGerados/fichaNotificaoPdf"
import { FichaNotificacaoReacoesAdversas } from "./documentosGerados/fichaReaccoesPdf"
import ProcessoLoading from "../../../../load/processoLoading"

const DownloadIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="tw-h-5 tw-w-5"
        aria-hidden="true"
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v11m0 0 4-4m-4 4-4-4M5 20h14" />
    </svg>
)

const ReadOnlyCheckbox = ({ label, checked }) => (
    <label className="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700">
        <input
            type="checkbox"
            checked={Boolean(checked)}
            readOnly
            className="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-bg-white tw-text-armed-700 focus:tw-ring-armed-500"
        />
        <span>{label}</span>
    </label>
)

const SectionCard = ({ title, children, actions }) => (
    <section className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 sm:tw-p-5 tw-shadow-sm">
        {title && <HeaderGestorConfigs title={title} />}
        {actions}
        <div>{children}</div>
    </section>
)

const formatarDataManifestacao = (valor, incluirHora = false) => {
    if (!valor) return ''
    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
    const d = new Date(valor)
    if (Number.isNaN(d.getTime())) return ''
    const dia = d.getDate()
    const mes = meses[d.getMonth()]
    const ano = d.getFullYear()
    if (incluirHora) {
        const hora = d.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' })
        return ` ${dia} de ${mes} as ${hora}h de ${ano}`
    }
    return `dia ${dia} ${mes} ${ano}`
}

export default function GestFarmacovigilancia({ element: component, ...rest }) {
    const { id } = useParams()
    const [notificacao, setNotificacao] = useState('')
    const user = useSelector(state => state.account.user)
    const [update, setUpdate] = useState(false)
    const handleChange = () => {}
    const [openApresentacao, setOpenApresentacao] = useState(false)
    const [apresentacaoData, setApresentacaoData] = useState(null)

    const opcoesApresentacao = [
        { key: 'a', label: 'Comprimidos/cápsulas orais' },
        { key: 'b', label: 'Suspensão, xaropes' },
        { key: 'c', label: 'Injecção' },
        { key: 'd', label: 'Diluente' },
        { key: 'e', label: 'Pó para reconstituição da suspensão' },
        { key: 'f', label: 'Pó para reconstituição de injectáveis' },
        { key: 'g', label: 'Gotas oftálmicas' },
        { key: 'h', label: 'Gotas nasais' },
        { key: 'i', label: 'Gotas auriculares' },
        { key: 'j', label: 'Nebulizadores' },
        { key: 'k', label: 'Cremes, pomadas, pastas, linimentos' },
    ]

    const opcoesDefeitos = [
        { key: 'a', label: 'Separação' },
        { key: 'b', label: 'Solidificação' },
        { key: 'c', label: 'Esfarelamento' },
        { key: 'd', label: 'Moldura defeituasa' },
        { key: 'e', label: 'Mudança de Cheiro' },
        { key: 'f', label: 'Mudança de cor' },
        { key: 'g', label: 'Rotulagem defeituosa' },
        { key: 'h', label: 'Acondicionamento defeituoso' },
        { key: 'i', label: 'Rotulagem e prospecto deficiente' },
    ]

    const abrirModalApresentacao = (item) => {
        let data = item?.apresentacaoProducto && typeof item.apresentacaoProducto === 'object'
            ? item.apresentacaoProducto
            : null

        if (!data) {
            const d = {}
            ;['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'].forEach(L => {
                d[L.toLowerCase()] = item?.[`identificacaoProductoApresentacaoProducto${L}`] === true
            })
            const outrosAntigo = item?.identificacaoProductoApresentacaoProductoOutros
            if (Object.values(d).some(Boolean) || outrosAntigo) {
                d.outros = outrosAntigo || ''
                data = d
            }
        }

        setApresentacaoData(data || {})
        setOpenApresentacao(true)
    }

    const getApresentacaoDataRaw = (item) => {
        let data = item?.apresentacaoProducto && typeof item.apresentacaoProducto === 'object'
            ? item.apresentacaoProducto
            : null
        if (!data) {
            const d = {}
            ;['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'].forEach((key, idx) => {
                const L = String.fromCharCode(65 + idx)
                d[key] = item?.[`identificacaoProductoApresentacaoProducto${L}`] === true
            })
            const outrosAntigo = item?.identificacaoProductoApresentacaoProdutoOutros || item?.identificacaoProductoApresentacaoProductoOutros
            if (Object.values(d).some(Boolean) || outrosAntigo) {
                d.outros = outrosAntigo || ''
                data = d
            }
        }
        return data || {}
    }

    const getDefeitosDataRaw = (item) => {
        const data = item?.defeitos && typeof item?.defeitos === 'object' ? item.defeitos : {}
        return data || {}
    }

    const getArmazenamentoRespostas = () => {
        const ca = notificacao?.conducoesArmazenamento || {}
        const pickResp = (k) => (ca?.[k]?.resposta || '').toString()
        const outrosDetalhes = (
            ca?.f?.outrosDetalhes ||
            ca?.a?.outrosDetalhes ||
            ca?.b?.outrosDetalhes ||
            ca?.c?.outrosDetalhes ||
            ca?.d?.outrosDetalhes ||
            ca?.e?.outrosDetalhes ||
            ''
        )
        return {
            requerRefrigeracao: pickResp('a'),
            jaFoiUsado: pickResp('b'),
            foiDevolvido: pickResp('c'),
            defeitoDetectado: pickResp('d'),
            armazenadoCorretamente: pickResp('e'),
            conducoesArmazenamentoOutrosDetalhes: outrosDetalhes,
        }
    }

    useEffect(() => {
        api.get(`/farmaco-vigilancia/${id}`)
            .then(response => {
                setNotificacao(response.data.farmacoVigilancia)
            })
            .catch(() => {})
    }, [id, update])

    const renderYesNoRow = (label, value) => (
        <div className="tw-grid tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-4">
            <p className="tw-text-sm tw-font-semibold tw-text-slate-800">{label}</p>
            <div className="tw-grid tw-gap-3 sm:tw-grid-cols-2">
                <ReadOnlyCheckbox label="Sim" checked={value === 'Sim'} />
                <ReadOnlyCheckbox label="Não" checked={value === 'Não'} />
            </div>
        </div>
    )

    return notificacao ? (
        <div className="tw-min-h-screen tw-bg-slate-50 tw-py-6">
            <div className="tw-mx-auto tw-max-w-[1400px] tw-px-4 sm:tw-px-6 lg:tw-px-8">
                <HeaderSession title={'GESTÃO DE NOTIFICAÇÃO'} />

                <div className="tw-grid tw-gap-6 lg:tw-grid-cols-[300px_minmax(0,1fr)]">
                    <aside className="tw-space-y-4">
                        <div className="tw-static lg:tw-sticky lg:tw-top-20 tw-space-y-4">
                            <NavLateral
                                observacoesFeitas={notificacao?.observacoes}
                                notificacao={notificacao}
                                setUpdate={setUpdate}
                            />
                        </div>
                    </aside>

                    <main className="tw-space-y-6">
                        {component && React.cloneElement(component, {
                            notificacao,
                            setNotificacao,
                        })}

                        {notificacao?.casualidadeRAM && (
                            <SectionCard title="Causalidade de RAM de acordo com o Algoritimo de Naranjo e Colab">
                                <InfoFieldGroup
                                    variant="subtitle2"
                                    isEdit={false}
                                    load={false}
                                    fields={[
                                        { label: '1. Existem estudos prévios sobre essa reacção?', value: notificacao?.casualidadeRAM?.pergunta1 },
                                        { label: '2. A reacção adversa ocorreu após administração do medicamento?', value: notificacao?.casualidadeRAM?.pergunta2 },
                                        { label: '3. O paciente melhora quando o medicamento é retirado ou quando se administra um antagonista específico?', value: notificacao?.casualidadeRAM?.pergunta3 },
                                        { label: '4. A reacção reaparece quando se readministra o medicamento?', value: notificacao?.casualidadeRAM?.pergunta4 },
                                        { label: '5. Excluindo o uso de medicamentos, existem outras causas capazes de determinar o surgimento da reacção?', value: notificacao?.casualidadeRAM?.pergunta5 },
                                        { label: '6. A reacção reaparece ao se administrar placebo?', value: notificacao?.casualidadeRAM?.pergunta6 },
                                        { label: '7. O medicamento foi detectado em sangue ou outros líquidos orgânicos em concentrações tóxicas?', value: notificacao?.casualidadeRAM?.pergunta7 },
                                        { label: '8. A reacção foi mais intensa quando se aumentou a dose ou menos intensa quando a dose foi reduzida?', value: notificacao?.casualidadeRAM?.pergunta8 },
                                        { label: '9. O paciente já apresentou alguma reacção semelhante ao mesmo medicamento ou outro similar?', value: notificacao?.casualidadeRAM?.pergunta9 },
                                        { label: '10. A reacção adversa foi confirmada por meio de alguma evidência objectiva?', value: notificacao?.casualidadeRAM?.pergunta10 },
                                        { label: 'Lenda / Tipo de Reacção', value: notificacao?.casualidadeRAM?.tipoReaccao },
                                        { label: 'Lenda / Pontuação', value: notificacao?.casualidadeRAM?.pontuacao },
                                    ]}
                                />
                            </SectionCard>
                        )}

                        <SectionCard>
                            <div className="tw-flex tw-justify-end">
                                <button
                                    type="button"
                                    onClick={() =>
                                        notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade'
                                            ? FichaNotificacaoProdutosBaixaQualidadePdf(notificacao)
                                            : FichaNotificacaoReacoesAdversas(notificacao)
                                    }
                                    className="tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-100 tw-text-slate-700 tw-transition hover:tw-bg-slate-200"
                                    aria-label="Baixar"
                                >
                                    <DownloadIcon />
                                </button>
                            </div>

                            <InfoFieldGroup
                                isEdit={false}
                                load={false}
                                fields={[
                                    { label: 'Estado', value: notificacao?.status, editable: false },
                                    { label: 'Número de notificação', value: notificacao?.numero, key: 'numero' },
                                    { label: 'Data da notificação', value: <DateView date={notificacao?.createdAt} />, key: 'createdAt' },
                                    { label: 'Data de entrada', value: <DateView date={notificacao?.dataNotificacao} />, key: 'dataNotificacao' },
                                    { label: 'Data de despacho', value: notificacao?.dataDespacho && <DateView date={notificacao?.dataDespacho} />, key: 'dataDespacho' },
                                    { label: 'Tipo de notificação', value: notificacao?.tipo, key: 'tipo' },
                                    { label: 'Dados relevantes do Laboratório', value: notificacao?.dadosRelevantesLaboratorio, key: 'dadosRelevantesLaboratorio' },
                                ]}
                            />
                        </SectionCard>

                        <SectionCard title="Entidade Sanitária">
                            <InfoFieldGroup
                                isEdit={false}
                                load={false}
                                fields={[
                                    { label: 'Unidade sanitária/Farmácia', value: notificacao?.unidadeSanitaria?.nome, key: 'nome' },
                                    { label: 'Serviço', value: notificacao?.unidadeSanitaria?.servico, key: 'servico' },
                                    { label: 'Província', value: notificacao?.unidadeSanitaria?.provincia, key: 'provincia' },
                                    { label: 'Município', value: notificacao?.unidadeSanitaria?.municipio, key: 'municipio' },
                                    { label: 'Bairro', value: notificacao?.unidadeSanitaria?.bairro, key: 'bairro' },
                                    { label: 'Rua', value: notificacao?.unidadeSanitaria?.rua, key: 'rua' },
                                    { label: '', value: <Email email={notificacao?.unidadeSanitaria?.email} />, key: 'email' },
                                ]}
                            />
                        </SectionCard>

                        {notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade' && (
                            <SectionCard title="Condições de armazenamento">
                                <div className="tw-space-y-4 tw-px-1">
                                    {renderYesNoRow('O Produto requer refrigeração?', getArmazenamentoRespostas().requerRefrigeracao)}
                                    {renderYesNoRow('O produto já foi usado na unidade sanitária?', getArmazenamentoRespostas().jaFoiUsado)}
                                    {renderYesNoRow('O produto foi entregue e devolvido pelo cliente/paciente?', getArmazenamentoRespostas().foiDevolvido)}
                                    {renderYesNoRow('O defeito foi detectado pela unidade sanitária?', getArmazenamentoRespostas().defeitoDetectado)}
                                    {renderYesNoRow('O Produto está armazenado de acordo com as Boas Práticas de Armazenamento?', getArmazenamentoRespostas().armazenadoCorretamente)}

                                    <div className="tw-grid tw-gap-2 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-4">
                                        <p className="tw-text-sm tw-font-semibold tw-text-slate-800">Outros detalhes:</p>
                                        <textarea
                                            readOnly
                                            value={getArmazenamentoRespostas().conducoesArmazenamentoOutrosDetalhes || ''}
                                            className="tw-min-h-[120px] tw-w-full tw-resize-none tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-3 tw-text-sm tw-text-slate-800 focus:tw-outline-none"
                                        />
                                    </div>
                                </div>
                            </SectionCard>
                        )}

                        {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' && (
                            <SectionCard title="Paciente">
                                <InfoFieldGroup
                                    isEdit={false}
                                    load={false}
                                    fields={[
                                        { label: 'Nome', value: notificacao?.paciente?.nome, key: 'nome' },
                                        { label: 'Telefone', value: notificacao?.paciente?.telefone, key: 'telefone' },
                                        { label: 'Email', value: notificacao?.paciente?.email, key: 'email' },
                                        { label: 'Idade', value: notificacao?.paciente?.idade, key: 'idade' },
                                        { label: 'Sexo', value: notificacao?.paciente?.sexo === 'M' ? 'Masculino' : notificacao?.paciente?.sexo === 'F' ? 'Femenino' : '', key: 'sexo' },
                                        { label: 'Provincia', value: notificacao?.paciente?.provincia, key: 'provincia' },
                                        { label: 'Municipio', value: notificacao?.paciente?.municipio, key: 'municipio' },
                                        { label: 'Bairro', value: notificacao?.paciente?.bairro, key: 'bairro' },
                                        { label: 'Peso', value: notificacao?.paciente?.peso, key: 'peso' },
                                        { label: 'Altura', value: notificacao?.paciente?.altura, key: 'altura' },
                                        { label: 'Raça', value: notificacao?.paciente?.raca, key: 'raca' },
                                        { label: '', value: <ReadOnlyCheckbox label="Gestante" checked={notificacao?.paciente?.gestante} />, key: '' },
                                    ]}
                                />

                                <div className="tw-mt-6 tw-space-y-4">
                                    <HeaderGestorConfigs title="Paciente / Antecedentes" />
                                    <div className="tw-grid tw-gap-3">
                                        <ReadOnlyCheckbox label="Médicos, Serológicos, Psiquiátrico" checked={notificacao?.paciente?.antecendentes?.medicosSP} />
                                        <ReadOnlyCheckbox label="Cirúrgicos" checked={notificacao?.paciente?.antecendentes?.cirurgicos} />
                                        <ReadOnlyCheckbox label="De Abuso ou Dependência" checked={notificacao?.paciente?.antecendentes?.abusoDependencia} />
                                        <ReadOnlyCheckbox label="Alergias conhecidas" checked={notificacao?.paciente?.antecendentes?.alergiasConhecidas} />
                                    </div>
                                </div>
                            </SectionCard>
                        )}

                        {notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade' ? (
                            <SectionCard title="Identificação do produto">
                                <div className="tw-overflow-x-auto tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white">
                                    <table className="tw-min-w-full tw-divide-y tw-divide-slate-200 tw-text-sm">
                                        <thead className="tw-bg-slate-50">
                                            <tr>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Nome comercial / DCI</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Número do lote</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Data de fabrico</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Data de expiração</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Data de recepção</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Fabricante</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Fornecedor</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tw-divide-y tw-divide-slate-200 tw-bg-white">
                                            {(notificacao?.identificacaoProducto || []).map((item, index) => (
                                                <Fragment key={index}>
                                                    <tr className="tw-bg-white hover:tw-bg-slate-50">
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{[item?.nomeCormecial, item?.nomeDCI].filter(Boolean).join(' / ')}</td>
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.numeroLote || ''}</td>
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.dataFabrico ? <DateView date={item?.dataFabrico} /> : ''}</td>
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.dataExpiracao ? <DateView date={item?.dataExpiracao} /> : ''}</td>
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.dataRecepcao ? <DateView date={item?.dataRecepcao} /> : ''}</td>
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.nomeFabricante || ''}</td>
                                                        <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.nomeFornecedor || ''}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={7} className="tw-bg-slate-50 tw-px-3 tw-py-4">
                                                            <div className="tw-grid tw-gap-6 lg:tw-grid-cols-2">
                                                                <div>
                                                                    <p className="tw-mb-3 tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide tw-text-armed-700">Apresentação do produto</p>
                                                                    {(() => {
                                                                        const data = getApresentacaoDataRaw(item)
                                                                        const temAlgum = opcoesApresentacao.some(opt => Boolean(data?.[opt.key])) || Boolean(data?.outros)
                                                                        return temAlgum ? (
                                                                            <div className="tw-grid tw-gap-3">
                                                                                {opcoesApresentacao.map(opt => (
                                                                                    <ReadOnlyCheckbox
                                                                                        key={opt.key}
                                                                                        label={opt.label}
                                                                                        checked={Boolean(data?.[opt.key])}
                                                                                    />
                                                                                ))}
                                                                                {data?.outros ? (
                                                                                    <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4">
                                                                                        <p className="tw-text-sm tw-font-semibold tw-text-slate-800">Outros</p>
                                                                                        <textarea
                                                                                            readOnly
                                                                                            value={data?.outros || ''}
                                                                                            className="tw-mt-2 tw-min-h-[120px] tw-w-full tw-resize-none tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3 tw-text-sm tw-text-slate-800"
                                                                                        />
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        ) : (
                                                                            <p className="tw-text-sm tw-text-slate-500">Sem informação</p>
                                                                        )
                                                                    })()}
                                                                </div>
                                                                <div>
                                                                    <p className="tw-mb-3 tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide tw-text-armed-700">Defeitos</p>
                                                                    {(() => {
                                                                        const data = getDefeitosDataRaw(item)
                                                                        const temAlgum = opcoesDefeitos.some(opt => Boolean(data?.[opt.key])) || Boolean(data?.outros)
                                                                        return temAlgum ? (
                                                                            <div className="tw-grid tw-gap-3">
                                                                                {opcoesDefeitos.map(opt => (
                                                                                    <ReadOnlyCheckbox
                                                                                        key={opt.key}
                                                                                        label={opt.label}
                                                                                        checked={Boolean(data?.[opt.key])}
                                                                                    />
                                                                                ))}
                                                                                {data?.outros ? (
                                                                                    <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4">
                                                                                        <p className="tw-text-sm tw-font-semibold tw-text-slate-800">Outros</p>
                                                                                        <textarea
                                                                                            readOnly
                                                                                            value={data?.outros || ''}
                                                                                            className="tw-mt-2 tw-min-h-[120px] tw-w-full tw-resize-none tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3 tw-text-sm tw-text-slate-800"
                                                                                        />
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        ) : (
                                                                            <p className="tw-text-sm tw-text-slate-500">Sem informação</p>
                                                                        )
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </SectionCard>
                        ) : (
                            <SectionCard title="Medicamentos">
                                <div className="tw-overflow-x-auto tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white">
                                    <table className="tw-min-w-full tw-divide-y tw-divide-slate-200 tw-text-sm">
                                        <thead className="tw-bg-slate-50">
                                            <tr>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">N.º</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Nome comercial / DCI</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Apresentação</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Dose diária</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Via e local de administração</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Motivo do tratamento</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Número do lote</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Data de caducidade</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Local de compra</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Início do tratamento</th>
                                                <th className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">Término do tratamento</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tw-divide-y tw-divide-slate-200 tw-bg-white">
                                            {(notificacao?.identificacaoProducto || []).map((item, index) => (
                                                <tr key={index} className="hover:tw-bg-slate-50">
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{index + 1}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{[item?.nomeCormecial, item?.nomeDCI].filter(Boolean).join(' / ')}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-armed-700">
                                                        <button
                                                            type="button"
                                                            onClick={() => abrirModalApresentacao(item)}
                                                            className="tw-text-sm tw-font-medium tw-text-armed-700 tw-underline tw-transition hover:tw-text-armed-900"
                                                        >
                                                            Ver apresentação
                                                        </button>
                                                    </td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.doseDiaria || ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.viaLocalAdmin || ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.motivoTratamento || ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.numeroLote || ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.dataExpiracao ? <DateView date={item?.dataExpiracao} /> : ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.localCompra || ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.InicioDataToma ? <DateView date={item?.InicioDataToma} /> : ''}</td>
                                                    <td className="tw-whitespace-nowrap tw-px-3 tw-py-3 tw-text-center tw-text-slate-700">{item?.terminoDataToma ? <DateView date={item?.terminoDataToma} /> : ''}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-5 tw-shadow-sm">
                                    <HeaderGestorConfigs title="Outras Indicações" />
                                    <div className="tw-grid tw-gap-3 tw-pt-3">
                                        <ReadOnlyCheckbox label="Automedicação" checked={notificacao?.automedicacao} />
                                        <ReadOnlyCheckbox label="Farmacodependência" checked={notificacao?.farmacodependencia} />
                                        <ReadOnlyCheckbox label="Erro Terapêutico" checked={notificacao?.erroTerapeutico} />
                                        <ReadOnlyCheckbox label="Campanha Vacinação" checked={notificacao?.campanhaVacinacao} />
                                    </div>
                                </div>
                            </SectionCard>
                        )}

                        {openApresentacao && (
                            <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/40 tw-px-4 tw-py-4 sm:tw-py-6">
                                <div className="tw-w-full tw-max-w-4xl tw-max-h-[90vh] tw-overflow-hidden tw-rounded-3xl tw-bg-white tw-shadow-2xl">
                                    <div className="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-border-b tw-border-slate-200 tw-px-4 sm:tw-px-6 tw-py-4">
                                        <h2 className="tw-text-lg tw-font-semibold tw-text-slate-900">Apresentação do produto</h2>
                                        <button
                                            type="button"
                                            onClick={() => setOpenApresentacao(false)}
                                            className="tw-self-end sm:tw-self-auto tw-rounded-full tw-bg-slate-100 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-200"
                                        >
                                            Fechar
                                        </button>
                                    </div>
                                    <div className="tw-space-y-6 tw-overflow-y-auto tw-px-4 sm:tw-px-6 tw-py-4 sm:tw-py-6">
                                        <div className="tw-grid tw-gap-4 sm:tw-grid-cols-2 lg:tw-grid-cols-3">
                                            {opcoesApresentacao.map(opt => (
                                                <div
                                                    key={opt.key}
                                                    className={`tw-rounded-3xl tw-border tw-p-4 ${apresentacaoData?.[opt.key] ? 'tw-border-armed-700 tw-bg-armed-700 tw-text-white' : 'tw-border-slate-200 tw-bg-slate-50 tw-text-slate-800'}`}
                                                >
                                                    <label className="tw-flex tw-items-center tw-gap-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={Boolean(apresentacaoData?.[opt.key])}
                                                            readOnly
                                                            className="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-bg-white tw-text-white"
                                                        />
                                                        <span className="tw-text-sm tw-font-medium">{opt.label}</span>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {apresentacaoData?.outros ? (
                                            <div className="tw-space-y-2">
                                                <p className="tw-text-sm tw-font-semibold tw-text-armed-700">Outros</p>
                                                <textarea
                                                    readOnly
                                                    value={apresentacaoData?.outros || ''}
                                                    className="tw-min-h-[120px] tw-w-full tw-resize-none tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3 tw-text-sm tw-text-slate-800"
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        )}

                        {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' && (
                            <SectionCard title="Efeitos Indesejáveis">
                                <div className="tw-space-y-6">
                                    <div className="tw-space-y-2">
                                        <p className="tw-text-sm tw-font-semibold tw-text-slate-800">Breve Descição de Efeito Indesejavel</p>
                                        <textarea
                                            readOnly
                                            value={notificacao?.efeitosIndesejados?.descricao ?? ''}
                                            rows={4}
                                            className="tw-min-h-[144px] tw-w-full tw-resize-none tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3 tw-text-sm tw-text-slate-800"
                                        />
                                    </div>
                                    {(notificacao?.efeitosIndesejados?.inicioManifestacao || notificacao?.efeitosIndesejados?.fimManifestacao) ? (
                                        <p className="tw-text-sm tw-leading-6 tw-text-slate-700">
                                            {`Prazo de manifestação: ${formatarDataManifestacao(notificacao?.efeitosIndesejados?.inicioManifestacao, true)}${(notificacao?.efeitosIndesejados?.inicioManifestacao && notificacao?.efeitosIndesejados?.fimManifestacao) ? ' à ' : ''}${formatarDataManifestacao(notificacao?.efeitosIndesejados?.fimManifestacao, false)}`}
                                        </p>
                                    ) : null}

                                    <div className="tw-grid tw-gap-4 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-4">
                                        <p className="tw-text-sm tw-font-semibold tw-text-slate-800">Evolução dos Efeitos indesejaveis</p>
                                        <div className="tw-grid tw-gap-2">
                                            <ReadOnlyCheckbox label="Risco de vida" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.riscoVida} />
                                            <ReadOnlyCheckbox label="Motivou hospitalização" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.motivouHospitalizacao} />
                                            <ReadOnlyCheckbox label="Prolongou hospitalização" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.prolongouHospitalizacao} />
                                            <ReadOnlyCheckbox label="Malformação Congênita" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.malformacaoCongenita} />
                                            <ReadOnlyCheckbox label="Não recuperou ainda" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.naoRecuperouAind} />
                                            <ReadOnlyCheckbox label="Recuperou sem sequelas" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.recuperouSemSequelas} />
                                            <ReadOnlyCheckbox label="Recuperou com sequelas" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.recuperouComSequelas} />
                                            <ReadOnlyCheckbox label="Desconhecido" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.desconhecido} />
                                            <ReadOnlyCheckbox label="Morte" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.morte} />
                                            <ReadOnlyCheckbox label="Suspendeu o Medicamento" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.suspendeuMedicamento} />
                                            <ReadOnlyCheckbox label="Diminuiu a dose do Medicamento" checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.diminuiuDoseMedicamento} />
                                        </div>
                                        <p className="tw-text-sm tw-text-slate-700">Efeito desapareceu após suspensão?: {notificacao?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIDDASDM}</p>
                                        <p className="tw-text-sm tw-text-slate-700">Efeito reapareceu após reintrodução?: {notificacao?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIRARDM}</p>
                                    </div>

                                    <div className="tw-space-y-2 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-4">
                                        <p className="tw-text-sm tw-font-semibold tw-text-slate-800">Tratamento Corrector</p>
                                        <textarea
                                            readOnly
                                            value={notificacao?.efeitosIndesejados?.descricao ?? ''}
                                            rows={4}
                                            className="tw-min-h-[144px] tw-w-full tw-resize-none tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-3 tw-text-sm tw-text-slate-800"
                                        />
                                    </div>
                                </div>
                            </SectionCard>
                        )}

                        <SectionCard title="Notificador">
                            <InfoFieldGroup
                                isEdit={false}
                                load={false}
                                fields={[
                                    { label: 'Nome', value: notificacao?.notificador?.nome, key: 'nome' },
                                    { label: 'Categoria Profissional', value: notificacao?.notificador?.categoriaProfissional, key: 'categoriaProfissional' },
                                    { label: 'Telefone', value: notificacao?.notificador?.tel, key: 'tel' },
                                    { label: 'Email', value: notificacao?.notificador?.email, key: 'email' },
                                ]}
                            />
                        </SectionCard>

                        {notificacao?.anexos && notificacao?.anexos.length > 0 && (
                            <SectionCard title="Imagens anexadas">
                                <AddAnexos addanexos={false} formData={notificacao || []} />
                            </SectionCard>
                        )}

                        <CreateObservacaoFarmacovigilancia
                            farmacoVigilanciaId={notificacao?._id}
                            userId={user._id}
                            setUpdate={setUpdate}
                        />

                        <ResponseFarmacovigilancia
                            farmacovigilancia={notificacao}
                            userId={user._id}
                            setUpdate={setUpdate}
                        />
                    </main>
                </div>
            </div>
        </div>
    ) : (
        <ProcessoLoading />
    )
}
